import {
  Button,
  CircularProgress,
  Divider,
  Paper,
  Typography,
} from "@mui/material";
import { CustomFormField } from "../../../../utilis/component/CustomFormElement";
import { Close, Save } from "@mui/icons-material";
import { useForm } from "react-hook-form";
import { FormOnChangeEventType } from "../../../../EMR/types";
import { useEffect, useRef, useState } from "react";
import { useMutation } from "react-query";
import {
  getAllCptGrpups,
  getCptByGroupId,
  saveRateService,
  uploadFile,
} from "../service";
import { assetsUrl, clinicId } from "../../../../constants";
import usePopup from "../../../../hooks/usePopup";
import debounce from "../../../../utilis/methods/networkHandling";
import { groupListResponseType, MasterTableDataType, saveRate } from "./type";
import { useLocation } from "react-router-dom";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import useAuthentication from "@hooks/useAuthentication";

function AddOrEdit({
  data,
  setData,
  setSuccess,
  success,
}: {
  data: MasterTableDataType | null;
  success: boolean;
  setData: React.Dispatch<React.SetStateAction<MasterTableDataType | null>>;
  setSuccess: React.Dispatch<React.SetStateAction<boolean>>;
}) {
  const pageTitle = "Insurance price";
  const { control, reset, handleSubmit, getValues, setValue } = useForm();
  const [openfileUpload, setOpenFileUpload] = useState<boolean>(false);
  const {user} = useAuthentication()
  const { showSnackbar, CustomModal } = usePopup();
  const fileRef = useRef<HTMLInputElement | null>(null);
  const location = useLocation() as { state?: { data?: any } };
  const refdata: MasterTableDataType | null = location.state?.data ?? null;

  const onSubmit = (formdata: any) => {
    const saveParams: saveRate = {
      id: data?.id ?? null,
      cptgroupId: formdata.cptGroup?.cptGroupId as number,
      cptId: formdata.cpt?.cptId as number,
      rate: formdata.rate,
      factor: formdata.factor ?? 1,
      needapproval: formdata.approvalRequired ?? false,
      createdById: Number(user?.userId),
      clinicId: clinicId,
      referenceId: refdata?.id as number,
      excluded: formdata.isExcluded ?? false,
    };
    // console.log("saveParams", formdata);
    saveRateData(saveParams);
  };

  const { mutate: saveRateData, isLoading } = useMutation(saveRateService, {
    onSuccess: (result) => {
      if (result.responseIndicator == "success") {
        setSuccess(!success);
        reset({
          cptGroup: null,
          cpt: null,
          factor: null,
          rate: null,
          isExcluded: false,
          approvalRequired: false,
        });
        showSnackbar({
          message: result.responseMessage,
          open: true,
          variant: "success",
          duration: 3000,
        });
      } else {
        showSnackbar({
          message: result.responseMessage,
          open: true,
          variant: "warning",
          duration: 3000,
        });
      }
    },
    onError: () => {
      showSnackbar({
        message: "Something went wrong",
        open: true,
        variant: "error",
        duration: 3000,
      });
    },
  });

  const { mutate: getcptGroups, data: groupList } =
    useMutation(getAllCptGrpups);

  const { mutate: getCptByGrp, data: cptList } = useMutation(getCptByGroupId);

  const onCptChange = (e: FormOnChangeEventType) => {
    const value = e?.target?.value;
    const params = {
      search: value,
      clinicId: clinicId,
      groupId: getValues("cptGroup")?.cptGroupId as number,
    };
    getCptByGrp(params);
  };

  const debouncedsearch = debounce(onCptChange, 500);

  const onChange = (e: FormOnChangeEventType) => {
    const value = e?.target?.value;
    console.log("value", value?.cptGroupId);

    if (value) {
      const params = {
        search: "",
        clinicId: clinicId,
        groupId: e?.target?.value?.cptGroupId as number,
      };
      getCptByGrp(params);
      reset({
        ...getValues(),
        cpt: null,
        factor: "",
        rate: "",
      });
    }
  };

  const { mutate: fileUpload, isLoading: uploadLoading } = useMutation(
    uploadFile,
    {
      onSuccess: (result) => {
        if (result.responseIndicator == "success") {
          setOpenFileUpload(false);
          fileRef.current!.value = "";
          showSnackbar({
            message: result.responseMessage,
            open: true,
            variant: "success",
            duration: 3000,
          });
          setSuccess(!success);
        } else {
          showSnackbar({
            message: result.responseMessage,
            open: true,
            variant: "warning",
            duration: 3000,
          });
        }
      },
      onError: (e: any) => {
        showSnackbar({
          message:
            e?.response?.data?.responseMessage || e?.response?.data?.errorMessage || "Something went wrong !",
          open: true,
          variant: "error",
          duration: 5000,
        });
      },
    }
  );

  const handleUploadFile = () => {
    if (fileRef.current?.files && fileRef.current.files.length > 0) {
      fileUpload({
        file: fileRef.current.files[0],
        refId: refdata?.id as number,
      });
    } else {
      showSnackbar({
        message: "Please select a file to upload !",
        open: true,
        variant: "warning",
        duration: 3000,
      });
    }
  };

  const handleOpenFileUpload = () => {
    setOpenFileUpload(true);
  };

  const onApprovalChange = () => {
    setValue("isExcluded", false);
  };
  const onExcludedChange = () => {
    setValue("approvalRequired", false);
  };

  useEffect(() => {
    getcptGroups();
    if (data) {
      const params = {
        search: "",
        clinicId: clinicId,
        groupId: data?.cptGrpId,
      };
      getCptByGrp(params);
      reset({
        factor: data?.factor,
        rate: data?.insRate,
        isExcluded: data?.isExcluded,
        approvalRequired: data?.approvalRequired,
        cptGroup: {
          cptGroupId: data?.cptGrpId,
          cptGroupName: data?.cptGroupName,
        },
        cpt: {
          cptId: data?.cptId,
          cptName: data?.cptName,
          cptCode: data?.cptCode,
        },
      });
    }
  }, [data]);

  return (
    <div className="p-3">
      <CustomModal
        open={openfileUpload || uploadLoading}
        setOpen={setOpenFileUpload}
        title={`Upload ${pageTitle} file`}
      >
        <div className="w-fit">
          <div className="p-4 flex justify-center">
            <input ref={fileRef} type="file" accept=".xls,.xlsx" />
            <Button
              variant="text"
              component="a"
              href={`${assetsUrl}/masters-sample-files/sample-priceList.xlsx`}
            >
              Download sample
            </Button>
          </div>
          <Divider />
          <div className=" p-3 flex justify-end items-center">
            <Button
              disabled={uploadLoading}
              onClick={handleUploadFile}
              endIcon={uploadLoading && <CircularProgress size={20} />}
            >
              upload
            </Button>
          </div>
        </div>
      </CustomModal>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Paper>
          <div className="flex justify-between items-center p-2">
            <div>
              <Typography variant="h6" className="p-3">
                {`${data != null ? "Edit" : "Add"} ${pageTitle}`}
              </Typography>
            </div>
            <div className="flex gap-2">
              <Button
                disabled={isLoading}
                color="error"
                type="reset"
                startIcon={<Close />}
                onClick={() => {
                  setData(null);
                  reset({
                    cptGroup: null,
                    cpt: null,
                    factor: null,
                    rate: null,
                    isExcluded: false,
                    approvalRequired: false,
                  });
                }}
              >
                reset
              </Button>
              <Button
                variant="outlined"
                onClick={handleOpenFileUpload}
                endIcon={<CloudUploadIcon />}
              >
                upload file
              </Button>
              <Button
                disabled={isLoading}
                type="submit"
                color="success"
                startIcon={
                  isLoading ? (
                    <CircularProgress size={20} color="success" />
                  ) : (
                    <Save />
                  )
                }
              >
                {data != null ? "update" : "Save"}
              </Button>
            </div>
          </div>
          <Divider />
          <div className="p-3 grid grid-cols-4 gap-3">
            <div className="">
              <CustomFormField
                control={control}
                name="cptGroup"
                element="autocomplete"
                fieldProps={{ label: "Cpt group" }}
                rules={{ required: "cpt group is required", onChange }}
                options={
                  Array.isArray(groupList?.response) ? groupList.response : []
                }
                autocompleteProps={{
                  isOptionEqualToValue: (
                    option: groupListResponseType,
                    value: groupListResponseType
                  ) => option?.cptGroupId == value?.cptGroupId,
                  getOptionLabel: (option: groupListResponseType) =>
                    option?.cptGroupName,
                }}
              />
            </div>
            
            <div className="">
              <CustomFormField
                control={control}
                name="cpt"
                element="autocomplete"
                fieldProps={{ label: "Cpt", onChange: debouncedsearch }}
                rules={{ required: "cpt is required" }}
                options={cptList?.response ?? []}
                autocompleteProps={{
                  isOptionEqualToValue: (option, value) =>
                    option?.cptId == value?.cptId,
                  getOptionLabel: (option) =>
                    `${option.cptCode}|| ${option?.cptName}`,
                  filterOptions: (option) => option,
                  renderOption: (props, option) => (
                    <li {...props} key={option.cptId}>
                      {option.cptCode} || {option.cptName}
                    </li>
                  ),
                }}
              />
            </div>

            <div className="">
              <CustomFormField
                control={control}
                name="rate"
                element="input"
                fieldProps={{ label: "Rate" }}
                rules={{ required: "rate is required" }}
              />
            </div>
            <div className="">
              <CustomFormField
                control={control}
                name="factor"
                element="input"
                fieldProps={{ label: "Factor" }}
                rules={{ required: "false" }}
              />
            </div>

            <div className="">
              <CustomFormField
                control={control}
                name="approvalRequired"
                element="checkbox"
                fieldProps={{ label: "Approval required" }}
                rules={{ required: false, onChange: onApprovalChange }}
              />
            </div>
            <div className="">
              <CustomFormField
                control={control}
                name="isExcluded"
                element="checkbox"
                fieldProps={{ label: "Is excluded" }}
                rules={{ required: false, onChange: onExcludedChange }}
              />
            </div>
          </div>
        </Paper>
      </form>
    </div>
  );
}

export default AddOrEdit;
